import './events'
import init from './init'
import instances from './lib/instances'

export const RocketEffectStylePack = {init, instances}
window.RocketEffectStylePack = RocketEffectStylePack

init()
export default RocketEffectStylePack

